module.exports = __webpack_public_path__ + "static/img/G5_V1.e7e93e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/captation/img/G5_V1.png
// module id = g1ty
// module chunks = 1